(function () {

    "use strict";

    function bodyListController() {

        var vm = this;
        vm.iconClick = function (iconAction, item) {
            console.log(iconAction);
            console.log(item);
        };

    }

    bodyListController.$inject = [];

    angular.module("sphforms.main")
        .component("sphFormsBodyList", {
            controller: bodyListController,
            bindings: {
                title: "=",
                icon: "<",
                service: "=",
                aditionalLabels: "<",
                iconActions: "="
            },
            templateUrl: "modules/main/components/ui/basicList/bodyList/bodyList.template.html"
        });

}());